<template>
  <div class="">
  <!-- 弹框 -->
  <Modal
    v-model="editListModal"
    width="700"
    title="确认充值"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListForm')"
  >
  <Form
    ref="editListForm"
    label-position="right"
    :label-width="120"
    :rules="ruleValidate"
    :model="editListForm"
  >
    <span style="margin-left:50px;line-height:32px">确认流水单号{{flowNumble}}已到账</span>
    <div class="" style="margin-left:50px;line-height:32px">
      <div class=""
        v-for="(Apply, index) in imgArrUrl"
        value="Apply.index"
        key="Apply.index"
        style="display:inline-block;width:68px;height:68px;"
        @click="showPicList(index)"
      >
        <img style="width:100%;height:100%;object-fit:cover;" :src="Apply" alt="">
      </div>
    </div>
    <FormItem label="充值金额"
      prop="handle_price"
      label-for="handle_price"
    >
      <Input
        placeholder="请输入充值金额"
        element-id="handle_price"
        v-model="editListForm.handle_price"
      ></Input>
    </FormItem>
</Form>
</Modal>
<PicsModal
  :pics="picList"
  :visible="picModel"
  :index="picIndex"
  @on-close="picModel = false"
/>
</div>
</template>

<script>
import PicsModal from '@/components/PicsModal'

export default {
  components: {
    PicsModal
  },
  props: {
    ApplyId: {
      type: Number,
      required: true
    },
    editModal: {
      type: Boolean,
      required: true
    },
    flowNumble: {
      type: String,
      required: true
    },
    imgArr: {
      type: String,
      required: true
    },
    price: {
      type: Number
    }
  },
  data () {
    return {
      urlImg: '',
      picModel: false,
      picList: [],
      picIndex: 0,
      listLoading: false,
      loading: true,
      defaultImgList: [],
      editListModal: this.editModal,
      editListForm: {
        handle_price: this.price + ''
      },
      ruleValidate: {
        handle_price: [
          { required: true, message: '请输入充值金额', trigger: 'blur' }
        ]
        // img_urls: [
        //   { required: true, message: '最少提交一张开票凭证图片', trigger: 'blur' }
        // ]
      }
    }
  },
  computed: {
    imgArrUrl () {
      if (this.imgArr !== null) {
        let arr = this.imgArr.split(',')
        return arr
      }
    }
  },
  watch: {
    editModal (val) {
      this.editListModal = val
      if (val) {
        this.reload()
      }
    },
    editListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    },
    price (val) {
      this.editListForm.handle_price = this.price + ''
    }
  },
  methods: {
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            id: this.ApplyId,
            ...this.editListForm
          }
          let url = '/agent/account/recharge/handle'
          this.$http.put(url, data).then(res => {
            if (res.success) {
              this.$Message.success('充值成功')
              this.editListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    showPicList (index) {
      this.picModel = true
      let arrImg = this.imgArrUrl[index]
      if (arrImg.length !== 0) {
        this.picList.push(arrImg)
      }
    },
    reload () {
      this.defaultImgList = []
      this.editListForm = {
        handle_price: ''
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/handle/topUpManage/EditSuccess.vue